module.exports = __webpack_public_path__ + "img/icon-todoorder.7a0e89a6.png";